import styled from '@emotion/styled/macro'
import mq from 'mediaQuery'

const TopBar = styled('div')`
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;

  ${mq.medium`
    padding: 50px 0 20px;
    justify-content: flex-end;
  `}
`

export default TopBar
